import getVideoId from 'get-video-id';

const fragmentFromString = (html: string) => document.createRange().createContextualFragment(html);

const template = ({ id }: { id: string }) =>
  fragmentFromString(`
  <div class="focuswriter-youtubeembed-player">
    <iframe
      type="text/html"
      width="100%"
      class="focuswriter-youtubeembed-player__iframe"
      src="https://www.youtube.com/embed/${id}?autoplay=0&showinfo=0&rel=0&color=white"
      frameborder="0"
    ></iframe>
  </div>
`);

const enhanceFocuswriterYoutubeEmbed = () => {
  document.querySelectorAll('[data-focuswriter-youtubeembed]').forEach((prevElement) => {
    const url = prevElement.getAttribute('data-focuswriter-youtubeembed');
    if (!url) return;

    const { id, service } = getVideoId(url);
    if (!id || service !== 'youtube') return;

    const nextElement = template({ id });
    prevElement.replaceWith(nextElement);
  });
};

export default enhanceFocuswriterYoutubeEmbed;
